import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon, FootprintsIcon, RepeatIcon, HomeIcon } from 'lucide-react';
const benefits = [{
  text: 'Saber exactamente qué hacer cada noche en menos de 10 minutos',
  icon: ClockIcon
}, {
  text: 'Pies sin grietas, sin dolor y sin descuido en 7 días',
  icon: FootprintsIcon
}, {
  text: 'Una rutina tan simple que no la vas a querer abandonar',
  icon: RepeatIcon
}, {
  text: 'Pasos claros que puedes seguir desde casa sin gastar de más',
  icon: HomeIcon
}];
export function Benefits() {
  return <section className="py-24 bg-sage text-cream" data-id="element-26">
      <div className="max-w-6xl mx-auto px-6" data-id="element-27">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-28">
          <h2 className="text-3xl md:text-4xl font-serif mb-4 text-white" data-id="element-29">
            Lo que esta guía puede aportarte
          </h2>
          <div className="w-16 h-[1px] bg-bronze mx-auto" data-id="element-30" />
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-31">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-start gap-5 p-6 border border-white/15 bg-white/5" data-id="element-32">
              <benefit.icon className="w-6 h-6 text-bronze shrink-0 mt-1" strokeWidth={1.5} data-id="element-33" />
              <p className="text-cream/90 font-medium leading-relaxed" data-id="element-34">
                {benefit.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}